module.exports = __webpack_public_path__ + "media/images/home/flow_r_index_3-408de352cf0e032f9739e71a064e73be.svg";